import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Container,
  Input,
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  CustomInput,
  Modal,
  ModalBody,
  ModalHeader
} from 'reactstrap';
import { connect } from 'react-redux';
import { IEncaissementReduxProps, IEncaissementsListTable } from '../../types/interfaces';
import EncaissementScanModal from './EncaissementScanModal';
import EncaissementCommissionedToEdit from './EncaissementCommissionedToEdit';
import EncaissementEdit from './EncaissementEdit';

import { editEncaissementAnpv, editEncaissementModeReg } from '../../flux/actions/encaissementActions';
import TableContainer from "../tables_manager/TableContainer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckCircle, faDownload, faExternalLinkAlt, faFileInvoice, faMoneyCheck, faPen, faPrint, faReceipt, faRedo, faSpinner, faUndo } from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";
import Select from 'react-select';

import { DateRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import Loading from '../Loading';
import PDFLink from '../pdf/PDFLink';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';
import { E_ERROR } from '../../types/errors';
import { getEncModeRegl, getEncStatut } from "../../services/misc";
import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges';

const EncaissementListTable = ({ 
  encaissementsData,
  setTableData,
  setFilteredRows,
  showProjectColumn,
  showStatutColumn,
  isNotairePage,
  impayePopup,
  commissionBlockPopup,
  isDelayPage,
  isAnpvPage,
  isVersesList,
  editEncaissementAnpv,
  editEncaissementModeReg,
  onCheck,
  user,
  auth
 }: IEncaissementsListTable) => {
  const history = useHistory();
  const alert = useAlert();
  const { users } = user
  const modereglementOptions = [constants.MODE_REGL_CHEQUE, constants.MODE_REGL_VERSEMENT, constants.MODE_REGL_VIREMENT].map(e => ({value: e, label: getEncModeRegl(e)}));
  const [modeReglementValue, setModeReglementValue] = useState<any>(modereglementOptions[0]);
  const [modal, setModal] = useState(false);
  const [modalEncaissement, setModalEncaissement] = useState<any>('');
  const [modalEdit, setModalEdit] = useState(false);
  const [modalEditData, setModalEditData] = useState<any>(undefined);
  const [modalEditAnpv, setModalEditAnpv] = useState(false);
  const [modalEditAnpvData, setModalEditAnpvData] = useState<any>(undefined);
  const [editCommissionedToModal, setEditCommissionedToModal] = useState(false);
  const [modalEditCommissionedToData, setModalEditCommissionedToData] = useState('');
  const [modalEditModeReg, setModalEditModeReg] = useState(false);
  const [modalEditModeRegData, setModalEditModeRegData] = useState<any>(undefined);
  const [idValue, setIdValue] = useState(-1);
  const [nepasverserValue, setNepasverserValue] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const handleToggleEdit = () => setModalEditAnpv(!modalEditAnpv)
  const handleToggleEditModeReg = () => setModalEditModeReg(!modalEditModeReg)
  
  const handleModeReglementChange = data => {
    setModeReglementValue(data || '');
  }

  const modalOpenedHandleEdit = () => {
    if(modalEditAnpvData){
      setIdValue(modalEditAnpvData["id"]);
      setNepasverserValue(!!(modalEditAnpvData["STATUT"] === constants.STATUT_ENC_A_NE_PAS_VERSER_NR || modalEditAnpvData["STATUT"] === constants.STATUT_ENC_A_NE_PAS_VERSER_R));
    }
  }

  const modalOpenedHandleEditModeReg = () => {
    if(modalEditModeRegData){
      setIdValue(modalEditModeRegData["id"]);
      setModeReglementValue(modereglementOptions.find(e => e.value === modalEditModeRegData["MODE_REGL"]) || '');
      // setNepasverserValue(!!(modalEditData["STATUT"] === constants.STATUT_ENC_A_NE_PAS_VERSER_NR || modalEditData["STATUT"] === constants.STATUT_ENC_A_NE_PAS_VERSER_R));
    }
  }

  const modalClosedHandleEdit = () => {
    setIdValue(-1);
    setNepasverserValue(false);
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  }

  const modalClosedHandleEditModeReg = () => {
    setIdValue(-1);
    // setNepasverserValue(false);
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  }

  const changeNepasverserHandle = (e) => {
    setNepasverserValue(e.target.checked);
  };

  const callback = (success) => {
    if(success && !success.err){
      setReEnable(true);
      setModalEditAnpv(false);
      alert.success("Encaissement modifié avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    if(!idValue)
      return
    setDisableSubmit(true);
    editEncaissementAnpv(idValue, nepasverserValue ? 1 : 0, callback);
  };

  const callbackModeReg = (success) => {
    if(success && !success.err){
      setReEnable(true);
      setModalEditModeReg(false);
      alert.success("Encaissement modifié avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editModeRegHandle = async () => {
    if(!idValue || !modeReglementValue)
      return
    setDisableSubmit(true);
    editEncaissementModeReg(idValue, modeReglementValue.value, callbackModeReg);
  };

  const columns = [
    ...(isDelayPage ? [
      {
        Header: "Statut Prolongation",
        accessor: e => e.dateVerseDelayValid === -1 ? "Pas encore validée" : e.dateVerseDelayValid === 0 ? "Refusée" : e.dateVerseDelayValid === 1 ? "Acceptée" : "-",
        Filter: SelectColumnFilter,
        filter: 'equals',
      },
      {
        Header: "Date prolongée",
        accessor: "dateVerseDelayDate",
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        customExportDisplay: `$.dateVerseDelayDate ? new Date($.dateVerseDelayDate) : "-"`,
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
      },
      {
        Header: "Commentaire Demande",
        accessor: "dateVerseDelayComment",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Demandée par",
        accessor: e => users?.find(t => t.id === e.dateVerseDelayReqBy)?.username || "",
        Cell: ({ value, row: {original} }) => `${value || "-"}, le ${original.dateVerseDelayReqAt ? moment(original.dateVerseDelayReqAt).format('DD/MM/YYYY') : "-"}`
      },
      {
        Header: "Demandée le",
        accessor: "dateVerseDelayReqAt",
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        customExportDisplay: `$.dateVerseDelayReqAt ? new Date($.dateVerseDelayReqAt) : "-"`,
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
        hidden: true
      },
      {
        Header: "Acceptée/refusée par",
        accessor: e => users?.find(t => t.id === e.dateVerseDelayCheckedBy)?.username || "",
        Cell: ({ value, row: {original} }) => `${value || "-"}, le ${original.dateVerseDelayCheckedAt ? moment(original.dateVerseDelayCheckedAt).format('DD/MM/YYYY') : "-"}`
      },
      {
        Header: "Acceptée/refusée le",
        accessor: "dateVerseDelayCheckedAt",
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        customExportDisplay: `$.dateVerseDelayCheckedAt ? new Date($.dateVerseDelayCheckedAt) : "-"`,
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
        hidden: true
      }
    ] : []),
    ...(isAnpvPage ? [
      {
        Header: "Statut Demande",
        accessor: e => e.anpvValid === -1 ? "Pas encore validée" : e.anpvValid === 0 ? "Refusée" : e.anpvValid === 1 ? "Acceptée" : "-",
        Filter: SelectColumnFilter,
        filter: 'equals',
      },
      {
        Header: "Commentaire Demande",
        accessor: "anpvValidComment",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Demandée par",
        accessor: e => users?.find(t => t.id === e.anpvValidReqBy)?.username || "",
        Cell: ({ value, row: {original} }) => `${value || "-"}, le ${original.anpvValidReqAt ? moment(original.anpvValidReqAt).format('DD/MM/YYYY') : "-"}`
      },
      {
        Header: "Demandée le",
        accessor: "anpvValidReqAt",
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        customExportDisplay: `$.anpvValidReqAt ? new Date($.anpvValidReqAt) : "-"`,
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
        hidden: true
      },
      {
        Header: "Acceptée/refusée par",
        accessor: e => users?.find(t => t.id === e.anpvValidCheckedBy)?.username || "",
        Cell: ({ value, row: {original} }) => `${value || "-"}, le ${original.anpvValidCheckedAt ? moment(original.anpvValidCheckedAt).format('DD/MM/YYYY') : "-"}`
      },
      {
        Header: "Acceptée/refusée le",
        accessor: "anpvValidCheckedAt",
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        customExportDisplay: `$.anpvValidCheckedAt ? new Date($.anpvValidCheckedAt) : "-"`,
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
        hidden: true
      }
    ] : []),
    ...(commissionBlockPopup ? [{
      Header: "Raison blocage",
      accessor: "commissionBlockReason",
      Filter: SelectColumnFilter,
      filter: 'equals',
    }] : []),
    ...(onCheck ? [{
      Header: "Choisir",
      className: "text-center",
      Cell: ({ row }) => (
          <Container className="actionsContainer">
            <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"
              onClick={() => onCheck(row.original)}
              title="Choisir">
              <FontAwesomeIcon icon={faCheck} />
            </button>
          </Container>
      ),
      disableSortBy: true,
    }] : []),
    {
      Header: "Aperçus",
      className: "text-center",
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row: {original} }) => <div className="actionsContainer">
          {original.recto_name || original.verso_name || original.URL || original.URL_VERSO ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
            onClick={() => (setModalEncaissement(original), setModal(true))}
            title="Aperçu des Scans">
            <FontAwesomeIcon icon={faMoneyCheck} />
          </button> : null}
          {!!(isVersesList && original.MODE_REGL === constants.MODE_REGL_CHEQUE && original.STATUT && [constants.STATUT_ENC_EI, constants.STATUT_ENC_ENCAISSE, constants.STATUT_ENC_IMPAYE, constants.STATUT_ENC_REPRESENTE, constants.STATUT_ENC_NOTAIRE].includes(original.STATUT)) && <PDFLink documentType={"bordereau"}
            data={{encaissements: [original], bvData: original.banque_versement}}
            download={false}
            buttonText=""
            iconSize="inherit"
            // customClassNames="btn btn-info"
            customButtonIcon={faReceipt}
            allowPrintPreview={true}
            htmlTitle={`Imprimer le bordereau`}
            customClassNames="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
            style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} />}
          {original.contrat_encaissements?.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map((e, key) => e?.contrat ? <PDFLink documentType={"vente"}
            func={async () => getVenteByIdPromise(e.contrat.id || -1)}
            download={false}
            buttonText=""
            iconSize="inherit"
            // customClassNames="btn btn-info"
            customButtonIcon={faFileInvoice}
            allowPrintPreview={true}
            htmlKey={key}
            htmlTitle={`Voir la fiche de Vente - Dossier N° ${e.contrat.NUM_DOSS}`}
            customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
            style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} /> : null) || null}
          {!!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_ENCAISSEMENT) && <button className="btn btn-warning btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
            onClick={() => {setModalEditData(original); setModalEdit(true)}}
            title="Modifier">
            <FontAwesomeIcon icon={faPen} />
          </button>}
        </div>
    },
    // {
    //   Header: "Nouvelle Application",
    //   accessor: (row, index) => row.recto_name ? "Oui" : "Non",
    //   Filter: SelectColumnFilter,
    //   filter: 'equals',
    // },
    // {
    //   Header: "Saisie PAR",
    //   accessor: "SAISIE_PAR",
    // },
    // {
    //   Header: "enc_supp",
    //   accessor: (row, index) => row.contrat_encaissements?.length ? row.contrat_encaissements[0].enc_supp : "",
    // },
    {
      Header: "ID Système",
      accessor: "id",
      // hidden: true
    },
    {
      Header: "Projet",
      id: "Projet",
      accessor: (row, index) => row.societe?.LIBELE || row.PROJET || "",
      customExportDisplay: `($.societe && $.societe.LIBELE ? $.societe.LIBELE : undefined) || $.PROJET || ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      className: "text-center",
      Cell: ({ value, row: {original} }) => value || "-",
      hidden: !showProjectColumn
    },
    {
      Header: "N° Doss.",
      accessor: "NUM_DOSS",
      filter: (rows, id, e) => rows.filter(t => (t.original.contrat_encaissements?.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.NUM_DOSS || "-") || []).includes(e)),
      customExportDisplay: `($.contrat_encaissements && $.contrat_encaissements.length) ? $.contrat_encaissements.filter((e, index, self) => self.findIndex(t => (t.contrat ? t.contrat.id : undefined) === (e.contrat ? e.contrat.id : undefined)) === index).map(t => t.contrat && t.contrat.NUM_DOSS ? t.contrat.NUM_DOSS : "-").join(" / ") : "-"`,
      // Cell: ({ row: {original} }) => original.contrat_encaissements?.length ? original.contrat_encaissements.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.NUM_DOSS || "-").join(" et ") : "-",
      Cell: ({ row: {original} }) => {
        return (<div style={{display: "inline-block"}}>{original.contrat_encaissements?.length ? original.contrat_encaissements.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map((t, key) => <a key={key} href={t.contrat?.id !== null && t.contrat?.id !== undefined ? (`/consultation/${t.contrat.id}`) : '/#'} onClick={(e) => {
          e.preventDefault();
          if(t.contrat?.id !== null && t.contrat?.id !== undefined){
            if (e.ctrlKey){
              window.open('/consultation/' + t.contrat.id,'_blank');
              return;
            }
            history.push({ pathname: `/consultation/${t.contrat.id}` })
          }
          else
            alert.error(E_ERROR.NO_VENTE_WITH_THIS_ID)
        }}><button className="openLinkBtn">{t.contrat?.NUM_DOSS || "-"}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>) : "-"}</div>)
      }
    },
    {
      Header: "Chargé du Bien",
      accessor: e => e.contrat_encaissements.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.chargeBienUser?.LOGIN || "-").join(", "),
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Tiré par",
      accessor: "TIRE_PAR",
      Cell: ({ row: {original} }) => original.TIRE_PAR || "-",
      hidden: !!isNotairePage
    },
    {
      Header: "Mode de règlement",
      id: "Mode de règlement",
      accessor: (row, index) => getEncModeRegl(row.MODE_REGL),
      customExportDisplay: `getEncModeReglHandle($.MODE_REGL)`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      // Cell: ({ value, row: {original} }) => <>{value || "-"} {auth?.user?.privileges?.includes(PRIVILEGE.EDIT_ENCAISSEMENT) ? <FontAwesomeIcon icon={faPen} className="inTableColumnBtn" title="Modifier" onClick={() => {setModalEditModeRegData(original); setModalEditModeReg(true)}} /> : null}</>,
    },
    {
      Header: "Type échéance",
      accessor: "TYPE_ECHEANCE",
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      hidden: !!isNotairePage
    },
    {
      Header: "Réf. Règlement",
      accessor: "REF_REGLEMENT",
      Cell: ({ row: {original} }) => original.REF_REGLEMENT || "-"
    },
    {
      Header: "Montant encaissé",
      accessor: "MONTANT",
      filter: 'equals',
      Footer: e => {
        const total = useMemo(
          () =>
            e.rows.reduce((e, row) => e + Number(row.original.MONTANT || 0), 0),
          [e.rows]
        )

        return <div style={{display: "flex", justifyContent: "space-between"}}>
          <div>Total: </div>
          <div style={{textAlign: "right", fontWeight: 600, fontSize: "large"}}>{total.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div>
        </div>
      },
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
    },
    {
      Header: "Banque",
      accessor: "BANQUE",
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ row: {original} }) => original.BANQUE || "-"
    },
    {
      Header: "Date Encaissement",
      accessor: "DATE_REGLEMENT",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.DATE_REGLEMENT ? new Date($.DATE_REGLEMENT) : "-"`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
    },
    {
      Header: "Date de CHQ/VAL",
      accessor: "DATE_PORTEFEUILLE",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.DATE_PORTEFEUILLE ? new Date($.DATE_PORTEFEUILLE) : "-"`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: !!isNotairePage
    },
    {
      Header: "Saisie le",
      accessor: "createdAt",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.createdAt ? new Date($.createdAt) : "-"`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: !!isNotairePage
    },
    {
      Header: "Saisie par",
      accessor: (row, index) => row.user?.LOGIN || row.SAISIE_PAR || "",
      customExportDisplay: `$.user ? $.user.LOGIN : ($.SAISIE_PAR || "")`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      hidden: !!isNotairePage
    },
    {
      Header: "Bénéficiaire de commission",
      id: "Bénéficiaire de commission",
      accessor: e => e.commissionedToEUser?.LOGIN || "",
      customExportDisplay: `$.commissionedToEUser ? $.commissionedToEUser.LOGIN : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value, row: {original} }) => <>{value || "-"} {auth?.user?.privileges?.includes(PRIVILEGE.EDIT_COMMISSIONS) ? <FontAwesomeIcon icon={faPen} className="inTableColumnBtn" title="Modifier" onClick={() => {setModalEditCommissionedToData(original); setEditCommissionedToModal(true)}} /> : null}</>,
      hidden: !!isNotairePage
      // hidden: true
    },
    {
      Header: "Commercial",
      accessor: e => e.COMMERCIAL || "",
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
      // hidden: true
    },
    {
      Header: "Type Client",
      accessor: e => e.typeClient === 3 ? "Salarié" : e.typeClient === 2 ? "Promoteur" : "Client",
      Filter: SelectColumnFilter,
      filter: 'equals',
      hidden: true
    },
    ...(showStatutColumn ? [{
      Header: "Statut",
      accessor: row => getEncStatut(row.STATUT),
      customExportDisplay: `getEncStatutHandle($.STATUT)`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value, row: {original} }) => <>{value || "-"}{!!(original.STATUT && [constants.STATUT_ENC_DEFAULT, constants.STATUT_ENC_PTF, constants.STATUT_ENC_A_NE_PAS_VERSER_NR, constants.STATUT_ENC_A_NE_PAS_VERSER_R].includes(original.STATUT)) && <>&nbsp;<FontAwesomeIcon icon={faPen} style={{fontSize: "small", cursor: "pointer"}} onClick={() => {setModalEditAnpv(true); setModalEditAnpvData(original)}} /></>}</>,
    }] : []),
    ...(showStatutColumn ? [{
      Header: "Réceptionné le",
      accessor: "date_reception",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      customExportDisplay: `$.date_reception ? new Date($.date_reception) : ""`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: true
    }] : []),
    ...(showStatutColumn ? [{
      Header: "Réceptionné par",
      accessor: "statut_ptf_bv_saisie_par",
      Cell: ({ value }) => value || "-",
      hidden: true
    }] : []),
    ...(showStatutColumn ? [{
      Header: "Versé le",
      accessor: "date_verse",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      customExportDisplay: `$.date_verse ? new Date($.date_verse) : ""`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: true
    }] : []),
    ...(showStatutColumn ? [{
      Header: "Versé par",
      accessor: "statut_ptf_siege_saisie_par",
      Cell: ({ value }) => value || "-",
      hidden: true
    }] : []),
    ...(showStatutColumn ? [{
      Header: "Encaissé/Impayé le",
      accessor: "date_encaisse_impaye",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      customExportDisplay: `$.date_encaisse_impaye ? new Date($.date_encaisse_impaye) : ""`,
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-",
      hidden: !isNotairePage
    }] : []),
    ...(showStatutColumn ? [{
      Header: "Encaissé/Impayé par",
      accessor: "statut_encaisse_impaye_saisie_par",
      Cell: ({ value }) => value || "-",
      hidden: true
    }] : []),
    ...(showStatutColumn ? [{
      Header: "Récupéré le",
      accessor: "statut_recupere_saisie_date",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      customExportDisplay: `$.statut_recupere_saisie_date ? new Date($.statut_recupere_saisie_date) : ""`,
      Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
          sameDay: '[Aujourd\'hui à] HH:mm',
          nextDay: 'DD/MM/YYYY à HH:mm',
          nextWeek: 'DD/MM/YYYY à HH:mm',
          lastDay: '[Hier à] HH:mm',
          lastWeek: 'DD/MM/YYYY à HH:mm',
          sameElse: 'DD/MM/YYYY à HH:mm'
      })}</div> : "-",
      hidden: true
    }] : []),
    ...(showStatutColumn ? [{
      Header: "Récupéré par",
      accessor: "statut_recupere_saisie_par",
      Cell: ({ value }) => value || "-",
      hidden: true
    }] : []),
    ...(showStatutColumn ? [{
      Header: "Banque versement",
      accessor: "BANQUE_VERSEMENT",
      Cell: ({ value }) => value || "-",
      hidden: true
    }] : []),
    {
      Header: "Envoyé compta.",
      accessor: e => e.envoyeCompta === 1 ? "Oui" : "Non",
      Filter: SelectColumnFilter,
      filter: 'equals',
      className: "text-center",
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Envoyé compta. le",
      accessor: "envoyeComptaAt",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      customExportDisplay: `$.envoyeComptaAt ? new Date($.envoyeComptaAt) : ""`,
      Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
          sameDay: '[Aujourd\'hui à] HH:mm',
          nextDay: 'DD/MM/YYYY à HH:mm',
          nextWeek: 'DD/MM/YYYY à HH:mm',
          lastDay: '[Hier à] HH:mm',
          lastWeek: 'DD/MM/YYYY à HH:mm',
          sameElse: 'DD/MM/YYYY à HH:mm'
      })}</div> : "-",
      hidden: true
    },
    {
      Header: "Ancien",
      id: "Ancien",
      accessor: (row, index) => row.is_old === 1 ? "Oui" : "Non",
      customExportDisplay: `$.is_old == 1 ? "Oui" : "Non"`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      className: "text-center",
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Observation",
      accessor: "OBSERVATION",
      Cell: ({ value }) => value || "-",
      hidden: true
    }
  ];

  const GetTable = () => <TableContainer columns={columns} data={encaissementsData} dataName="encaissements" enableCheckBox={false} isEditable={false} setFilteredRows={setFilteredRows} showFooter={!impayePopup && !commissionBlockPopup} bgColor={impayePopup || commissionBlockPopup ? "darkred" : undefined} hideFiltersByDefault={!!impayePopup} smallerCols={!!impayePopup || !!commissionBlockPopup} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>

  return (
    <div>
      {impayePopup ? <GetTable /> : <Container>
        <GetTable />
      </Container>}
      <EncaissementScanModal modal={modal} setModal={setModal} modalEncaissement={modalEncaissement} setModalEncaissement={setModalEncaissement} />
      <EncaissementCommissionedToEdit modal={editCommissionedToModal} setModal={setEditCommissionedToModal} modalData={modalEditCommissionedToData} />
      <Modal isOpen={modalEditAnpv} toggle={handleToggleEdit} onOpened={modalOpenedHandleEdit} onClosed={modalClosedHandleEdit}>
        <ModalHeader toggle={handleToggleEdit}><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Modification de l'encaissement</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup className="formCustomSwitch text-center">
                    {/* <Label for="signature">Signé par le client</Label> */}
                    <CustomInput type="switch" id="nepasverser" name="nepasverserSwitch" label="À ne pas verser" className="switchDanger" checked={nepasverserValue} onChange={changeNepasverserHandle} />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center stickyBottom">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={editHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalEditModeReg} toggle={handleToggleEditModeReg} onOpened={modalOpenedHandleEditModeReg} onClosed={modalClosedHandleEditModeReg}>
        <ModalHeader toggle={handleToggleEditModeReg}><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Modification de l'encaissement</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup style={{position: "relative"}}>
                    <Label for="modereglement">Mode de règlement</Label>
                    <Select
                      id="modereglement"
                      name="modereglement"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={modereglementOptions[0]}
                      value={modeReglementValue}
                      onChange={handleModeReglementChange}
                      isClearable={false}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      options={modereglementOptions}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center stickyBottom">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={editModeRegHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
      <EncaissementEdit modal={modalEdit} setModal={setModalEdit} modalData={modalEditData} />
    </div>
  );
};

const mapStateToProps = (state: IEncaissementReduxProps) => ({
  encaissement: state.encaissement,
  user: state.user,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { editEncaissementAnpv, editEncaissementModeReg })(EncaissementListTable);
